module.exports = __webpack_public_path__ + "static/media/llanta-layout.3242ab57.svg";